
<ng-container *ngIf="media && media.fields.file.contentType">
  <video 
    *ngIf="this.media.fields.file.contentType.match('video')"
    class="project-image is-full"
    [src]="lcpHelper.urlFromMedia(media)"
    loop="true" 
    autoplay="autoplay" 
    controls 
    muted
    >

    <source 
      [src]="lcpHelper.urlFromMedia(media)" 
      [type]="media.fields.file.contentType" />
    <!-- <source src="MY_VIDEO.webm" type="video/webm" /> -->
  </video>

  <!-- [class]="klass" -->

  <img     
    *ngIf="media.fields.file.contentType.match('image')"
    class="project-image is-full"
    [src]="lcpHelper.urlFromMedia(media)">
</ng-container>